export const insurancePlans = [
  {
    id: 1,
    name: 'PPO',
    description: null,
    createdAt: '2019-09-09T20:47:40.340Z',
    updatedAt: '2019-09-09T20:47:40.340Z',
    createdBy: null,
    updatedBy: null,
  },
  {
    id: 2,
    name: 'Medicare',
    description: null,
    createdAt: '2019-09-09T20:47:40.340Z',
    updatedAt: '2019-09-09T20:47:40.340Z',
    createdBy: null,
    updatedBy: null,
  },
  {
    id: 3,
    name: 'Medicaid',
    description: null,
    createdAt: '2019-09-09T20:47:40.340Z',
    updatedAt: '2019-09-09T20:47:40.340Z',
    createdBy: null,
    updatedBy: null,
  },
];
